import { layoutMultilineText, PDFPage, rgb, TextAlignment } from "pdf-lib";
import { isObject, isString } from "ramda-adjunct";
import { CommonDrawOptions, DocumentPlaceholder } from "../types";
import { isRTL } from "../utils";

export interface DataPlaceholderOptions {
  fontSize: number;
  placeholderKey: string;
  variant?: string;
}
export interface DataPlaceholderData {
  value: string | boolean;
  type: string;
}

export const dataDraw = (
  page: PDFPage,
  placeholder: DocumentPlaceholder<DataPlaceholderOptions, DataPlaceholderData>,
  { font }: CommonDrawOptions
) => {
  if (!placeholder.data || !isObject(placeholder.data)) {
    throw new Error("Data placeholder should have data");
  }
  const dataItem = placeholder.data;
  if (!dataItem) {
    throw new Error("Data placeholder should have data");
  }

  const x = placeholder.x * page.getSize().width;
  const y = page.getSize().height - placeholder.y * page.getSize().height;
  const width = placeholder.width * page.getSize().width;
  const height = placeholder.height * page.getSize().height;

  if (dataItem.value === true || (dataItem.type === "BOOLEAN" && !!dataItem.type)) {
    page.drawLine({
      start: { x: x, y: y },
      end: { x: x + width, y: y - height },
      thickness: 2,
      color: rgb(0, 0, 0),
    });
    page.drawLine({
      start: { x: x + width, y: y },
      end: { x: x, y: y - height },
      thickness: 2,
      color: rgb(0, 0, 0),
    });
  } else if (isString(dataItem.value)) {
    const { lines } = layoutMultilineText(dataItem.value, {
      alignment: isRTL(dataItem.value) ? TextAlignment.Right : TextAlignment.Left,
      font: font!,
      fontSize: placeholder.options.fontSize,
      bounds: {
        height: height,
        width: width,
        x: x,
        y: y - placeholder.options.fontSize,
      },
    });

    lines.forEach(({ text, x: lineX }, index) => {
      page.drawText(text, {
        x: lineX,
        y: y - placeholder.options.fontSize - placeholder.options.fontSize * index,
        size: placeholder.options.fontSize,
        font: font,
        maxWidth: width,
      });
    });
  }
};
